var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "out-box",
      style: _vm.styleConfig.width
        ? `width:${_vm.styleConfig.width};height:${_vm.styleConfig.height};`
        : "",
    },
    [
      _c("label", { class: _vm.formatClassByType(_vm.backgroundType) }, [
        _vm.picShow
          ? _c("img", { attrs: { src: _vm.imgShow, alt: "" } })
          : _vm._e(),
      ]),
      _vm.showFileName
        ? _c("p", { staticClass: "doc_name_wrapper" }, [
            _vm.picShow
              ? _c("em", {
                  staticClass: "el-icon-view",
                  on: { click: _vm.openImgPreview },
                })
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "doc_name",
                on: {
                  click: function ($event) {
                    return _vm.openImgPreview()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.docNameCopy))]
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "imgDialogView",
          attrs: {
            title: _vm.backgroundTypeTransformation(_vm.backgroundType),
            "append-to-body": true,
            "show-close": false,
            visible: _vm.centerDialogVisible,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
              },
            },
            [
              _vm.picShow
                ? _c("img", {
                    ref: "rotateImg",
                    staticStyle: { width: "90%" },
                    attrs: { src: _vm.imgShow, alt: "" },
                  })
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.rotate(0)
                    },
                  },
                },
                [_vm._v("左旋转")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.rotate(1)
                    },
                  },
                },
                [_vm._v("右旋转")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }